import React, { memo, useMemo } from 'react';
import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
import GeneralImageNew, { IGeneralImageDomain } from '@gp/components/GeneralImageNew';
import PlatformIcon from '@gp/components/PlatformIcon';
import LinkJump from '@gp/components/LinkJump';
import { queryJumpable } from '@gp/utils/common';
import './index.scss';

interface Props {
  domain?: IGeneralImageDomain;
  src: string;
  title: string;
  platform?: 'mobile' | 'pc' | 'console' | 'all platforms' | (string & {});
  platformPlaceHolder?: any;
  platformTranformSolt?: boolean;
  solt?: any;
  data?: any;
  toDetails?:
    | ((data: any, e: React.MouseEvent<Element, MouseEvent> | null, isJump: boolean) => string)
    | Function
    | null;
  isVisibleFixedCustomBubble?: boolean; // 是否展示固定格式气泡内容
  bubbleClassName?: string;
  bubbleStyle?: React.CSSProperties;
  customBubbleContent?: any;
  isShowAllContent?: boolean;
  generalImageProps?: {
    crossOrigin: 'anonymous' | (string & {});
  };
}

const DEFAULT_PROPS: Props = {
  domain: 'game',
  src: '',
  title: '',
  platform: '',
  platformPlaceHolder: null,
  platformTranformSolt: false,
  solt: null,
  data: null,
  toDetails: null,
  isVisibleFixedCustomBubble: false,
  bubbleClassName: '',
  bubbleStyle: {},
  customBubbleContent: null,
};

function ProjectItem(props: Props) {
  const {
    domain,
    src,
    title,
    platform,
    platformPlaceHolder,
    platformTranformSolt,
    solt,
    data,
    toDetails,
    isVisibleFixedCustomBubble,
    bubbleClassName,
    bubbleStyle,
    customBubbleContent,
    isShowAllContent,
    generalImageProps,
  } = props;

  // 是否可以跳转
  const isOnClick = useMemo(() => {
    return !!toDetails;
  }, [toDetails]);

  return (
    <div className="dbg-project-item-info">
      <LinkJump url={isOnClick ? toDetails?.(data, null, false) : ''}>
        <GeneralImageNew
          {...generalImageProps}
          domain={domain}
          width={54}
          height={54}
          className={`dbg-project-item-info-img ${isOnClick ? 'gp-cursor-pointer' : ''}`}
          // style={{borderRadius: '6px'}}
          src={src || ''}
          onClick={(e: React.MouseEvent<Element, MouseEvent>) => {
            if (!queryJumpable(e) || !isOnClick) return;
            toDetails?.(data, e, true);
          }}
        />
      </LinkJump>
      <div className="right-info">
        <LinkJump url={isOnClick ? toDetails?.(data, null, false) : ''}>
          <div
            className={`header-info ${isOnClick ? 'header-info-hover gp-cursor-pointer' : ''}`}
            onClick={(e: React.MouseEvent<Element, MouseEvent>) => {
              if (!queryJumpable(e) || !isOnClick) return;
              toDetails?.(data, e, true);
            }}
          >
            <EllipsisTextBubble
              className="dbg-project-item-info-text"
              text={title || '-'}
              ellipsisLineClamp={2}
              // style={{
              //   color: '#000',
              //   fontSize: 14,
              // }}
              bubbleClassName={bubbleClassName}
              bubbleStyle={{
                // height: 20,
                // lineHeight: '20px',
                ...bubbleStyle,
              }}
              isVisibleFixedCustomBubble={isVisibleFixedCustomBubble}
              customBubbleContent={customBubbleContent}
              isShowAllContent={isShowAllContent}
            />
          </div>
        </LinkJump>
        {platformTranformSolt ? solt : <PlatformIcon platform={platform} placeholder={platformPlaceHolder} />}
      </div>
    </div>
  );
}

// props的默认值
ProjectItem.defaultProps = DEFAULT_PROPS;

export default memo(ProjectItem);
